import { screenNameConstants, viewPathConstants } from "../../constants";
import Students from "./Courses/Students";
import Profile from "../CustomerPortal/Views/Profile/Profile";
import Dashboard from "../CustomerPortal/Views/Dashboard/Dashboard";
import UserCourses from "../PractitionerPortal/Courses/Courses";
import MyCompetitions from "../CustomerPortal/Views/MyCompetitions/MyCompetitions";
import DetailCompetition from "../CustomerPortal/Views/MyCompetitions/Page/DetailCompetition";
import MyEvents from "../CustomerPortal/Views/MyEvents/MyEvents";
import DetailEvent from "../CustomerPortal/Views/MyEvents/Page/DetailEvent";

export const InstructorRoutes = [
  {
    path: viewPathConstants.DASHBOARD,
    name: screenNameConstants.DASHBOARD,
    component: <Dashboard />,
    protected: true,
    hasSideBar: true,
  },
  {
    path: viewPathConstants.PROFILE,
    name: screenNameConstants.PROFILE,
    component: <Profile />,
    protected: true,
    hasSideBar: true,
  },
  {
    path: viewPathConstants.STUDENT_COURSES,
    name: screenNameConstants.MY_COURSES,
    component: <UserCourses />,
    protected: true,
    hasSideBar: true,
  },
  {
    path: viewPathConstants.My_COMPETITIONS,
    name: screenNameConstants.MY_COMPETITIONS,
    component: <MyCompetitions />,
    protected: true,
    hasSideBar: true,
  },
  {
    path: viewPathConstants.MY_COMPETITIONS_DETAIL,
    name: screenNameConstants.MY_COMPETITIONS,
    component: <DetailCompetition />,
    protected: true,
    hasSideBar: true,
  },
  {
    path: viewPathConstants.MY_EVENTS,
    name: screenNameConstants.My_EVENTS,
    component: <MyEvents />,
    protected: true,
    hasSideBar: true,
  },
  {
    path: viewPathConstants.MY_EVENTS_DETAIL,
    name: screenNameConstants.My_EVENTS,
    component: <DetailEvent />,
    protected: true,
    hasSideBar: true,
  },
];
